//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  sh: "Αγία Ελένη",
  lc: "Αγία Λουκία",
  bl: "Άγιος Βαρθολομαίος",
  vc: "Άγιος Βικέντιος και Γρεναδίνες",
  sm: "Άγιος Μαρίνος",
  mf: "Άγιος Μαρτίνος (Γαλλικό τμήμα)",
  sx: "Άγιος Μαρτίνος (Ολλανδικό τμήμα)",
  ao: "Αγκόλα",
  az: "Αζερμπαϊτζάν",
  eg: "Αίγυπτος",
  et: "Αιθιοπία",
  ht: "Αϊτή",
  ci: "Ακτή Ελεφαντοστού",
  al: "Αλβανία",
  dz: "Αλγερία",
  vi: "Αμερικανικές Παρθένες Νήσοι",
  as: "Αμερικανική Σαμόα",
  ai: "Ανγκουίλα",
  ad: "Ανδόρα",
  aq: "Ανταρκτική",
  ag: "Αντίγκουα και Μπαρμπούντα",
  um: "Απομακρυσμένες Νησίδες ΗΠΑ",
  ar: "Αργεντινή",
  am: "Αρμενία",
  aw: "Αρούμπα",
  au: "Αυστραλία",
  at: "Αυστρία",
  af: "Αφγανιστάν",
  vu: "Βανουάτου",
  va: "Βατικανό",
  be: "Βέλγιο",
  ve: "Βενεζουέλα",
  bm: "Βερμούδες",
  vn: "Βιετνάμ",
  bo: "Βολιβία",
  kp: "Βόρεια Κορέα",
  mk: "Βόρεια Μακεδονία",
  ba: "Βοσνία - Ερζεγοβίνη",
  bg: "Βουλγαρία",
  br: "Βραζιλία",
  io: "Βρετανικά Εδάφη Ινδικού Ωκεανού",
  vg: "Βρετανικές Παρθένες Νήσοι",
  fr: "Γαλλία",
  tf: "Γαλλικά Νότια Εδάφη",
  gf: "Γαλλική Γουιάνα",
  pf: "Γαλλική Πολυνησία",
  de: "Γερμανία",
  ge: "Γεωργία",
  gi: "Γιβραλτάρ",
  gm: "Γκάμπια",
  ga: "Γκαμπόν",
  gh: "Γκάνα",
  gg: "Γκέρνζι",
  gu: "Γκουάμ",
  gp: "Γουαδελούπη",
  wf: "Γουάλις και Φουτούνα",
  gt: "Γουατεμάλα",
  gy: "Γουιάνα",
  gn: "Γουινέα",
  gw: "Γουινέα Μπισάου",
  gd: "Γρενάδα",
  gl: "Γροιλανδία",
  dk: "Δανία",
  do: "Δομινικανή Δημοκρατία",
  eh: "Δυτική Σαχάρα",
  sv: "Ελ Σαλβαδόρ",
  ch: "Ελβετία",
  gr: "Ελλάδα",
  er: "Ερυθραία",
  ee: "Εσθονία",
  zm: "Ζάμπια",
  zw: "Ζιμπάμπουε",
  ae: "Ηνωμένα Αραβικά Εμιράτα",
  us: "Ηνωμένες Πολιτείες",
  gb: "Ηνωμένο Βασίλειο",
  jp: "Ιαπωνία",
  in: "Ινδία",
  id: "Ινδονησία",
  jo: "Ιορδανία",
  iq: "Ιράκ",
  ir: "Ιράν",
  ie: "Ιρλανδία",
  gq: "Ισημερινή Γουινέα",
  ec: "Ισημερινός",
  is: "Ισλανδία",
  es: "Ισπανία",
  il: "Ισραήλ",
  it: "Ιταλία",
  kz: "Καζακστάν",
  cm: "Καμερούν",
  kh: "Καμπότζη",
  ca: "Καναδάς",
  qa: "Κατάρ",
  cf: "Κεντροαφρικανική Δημοκρατία",
  ke: "Κένυα",
  cn: "Κίνα",
  kg: "Κιργιστάν",
  ki: "Κιριμπάτι",
  co: "Κολομβία",
  km: "Κομόρες",
  cd: "Κονγκό - Κινσάσα",
  cg: "Κονγκό - Μπραζαβίλ",
  cr: "Κόστα Ρίκα",
  cu: "Κούβα",
  kw: "Κουβέιτ",
  cw: "Κουρασάο",
  hr: "Κροατία",
  cy: "Κύπρος",
  la: "Λάος",
  ls: "Λεσότο",
  lv: "Λετονία",
  by: "Λευκορωσία",
  lb: "Λίβανος",
  lr: "Λιβερία",
  ly: "Λιβύη",
  lt: "Λιθουανία",
  li: "Λιχτενστάιν",
  lu: "Λουξεμβούργο",
  yt: "Μαγιότ",
  mg: "Μαδαγασκάρη",
  mo: "Μακάο ΕΔΠ Κίνας",
  my: "Μαλαισία",
  mw: "Μαλάουι",
  mv: "Μαλδίβες",
  ml: "Μάλι",
  mt: "Μάλτα",
  ma: "Μαρόκο",
  mq: "Μαρτινίκα",
  mu: "Μαυρίκιος",
  mr: "Μαυριτανία",
  me: "Μαυροβούνιο",
  mx: "Μεξικό",
  mm: "Μιανμάρ (Βιρμανία)",
  fm: "Μικρονησία",
  mn: "Μογγολία",
  mz: "Μοζαμβίκη",
  md: "Μολδαβία",
  mc: "Μονακό",
  ms: "Μονσεράτ",
  bd: "Μπανγκλαντές",
  bb: "Μπαρμπέιντος",
  bs: "Μπαχάμες",
  bh: "Μπαχρέιν",
  bz: "Μπελίζ",
  bj: "Μπενίν",
  bw: "Μποτσουάνα",
  bf: "Μπουρκίνα Φάσο",
  bi: "Μπουρούντι",
  bt: "Μπουτάν",
  bn: "Μπρουνέι",
  na: "Ναμίμπια",
  nr: "Ναουρού",
  nz: "Νέα Ζηλανδία",
  nc: "Νέα Καληδονία",
  np: "Νεπάλ",
  mp: "Νήσοι Βόρειες Μαριάνες",
  ky: "Νήσοι Κέιμαν",
  cc: "Νήσοι Κόκος (Κίλινγκ)",
  ck: "Νήσοι Κουκ",
  mh: "Νήσοι Μάρσαλ",
  gs: "Νήσοι Νότια Γεωργία και Νότιες Σάντουιτς",
  ax: "Νήσοι Όλαντ",
  pn: "Νήσοι Πίτκερν",
  sb: "Νήσοι Σολομώντος",
  tc: "Νήσοι Τερκς και Κάικος",
  fo: "Νήσοι Φερόες",
  fk: "Νήσοι Φόκλαντ",
  hm: "Νήσοι Χερντ και Μακντόναλντ",
  bv: "Νήσος Μπουβέ",
  nf: "Νήσος Νόρφολκ",
  im: "Νήσος του Μαν",
  cx: "Νήσος των Χριστουγέννων",
  ne: "Νίγηρας",
  ng: "Νιγηρία",
  ni: "Νικαράγουα",
  nu: "Νιούε",
  no: "Νορβηγία",
  za: "Νότια Αφρική",
  kr: "Νότια Κορέα",
  ss: "Νότιο Σουδάν",
  dm: "Ντομίνικα",
  nl: "Ολλανδία",
  bq: "Ολλανδία Καραϊβικής",
  om: "Ομάν",
  hn: "Ονδούρα",
  hu: "Ουγγαρία",
  ug: "Ουγκάντα",
  uz: "Ουζμπεκιστάν",
  ua: "Ουκρανία",
  uy: "Ουρουγουάη",
  pk: "Πακιστάν",
  ps: "Παλαιστινιακά Εδάφη",
  pw: "Παλάου",
  pa: "Παναμάς",
  pg: "Παπούα Νέα Γουινέα",
  py: "Παραγουάη",
  pe: "Περού",
  pl: "Πολωνία",
  pt: "Πορτογαλία",
  pr: "Πουέρτο Ρίκο",
  cv: "Πράσινο Ακρωτήριο",
  re: "Ρεϊνιόν",
  rw: "Ρουάντα",
  ro: "Ρουμανία",
  ru: "Ρωσία",
  ws: "Σαμόα",
  st: "Σάο Τομέ και Πρίνσιπε",
  sa: "Σαουδική Αραβία",
  sj: "Σβάλμπαρντ και Γιαν Μαγιέν",
  kn: "Σεν Κιτς και Νέβις",
  pm: "Σεν Πιερ και Μικελόν",
  sn: "Σενεγάλη",
  rs: "Σερβία",
  sc: "Σεϋχέλλες",
  sg: "Σιγκαπούρη",
  sl: "Σιέρα Λεόνε",
  sk: "Σλοβακία",
  si: "Σλοβενία",
  so: "Σομαλία",
  sz: "Σουαζιλάνδη",
  sd: "Σουδάν",
  se: "Σουηδία",
  sr: "Σουρινάμ",
  lk: "Σρι Λάνκα",
  sy: "Συρία",
  tw: "Ταϊβάν",
  th: "Ταϊλάνδη",
  tz: "Τανζανία",
  tj: "Τατζικιστάν",
  jm: "Τζαμάικα",
  je: "Τζέρζι",
  dj: "Τζιμπουτί",
  tl: "Τιμόρ-Λέστε",
  tg: "Τόγκο",
  tk: "Τοκελάου",
  to: "Τόνγκα",
  tv: "Τουβαλού",
  tr: "Τουρκία",
  tm: "Τουρκμενιστάν",
  tt: "Τρινιντάντ και Τομπάγκο",
  td: "Τσαντ",
  cz: "Τσεχία",
  tn: "Τυνησία",
  ye: "Υεμένη",
  ph: "Φιλιππίνες",
  fi: "Φινλανδία",
  fj: "Φίτζι",
  cl: "Χιλή",
  hk: "Χονγκ Κονγκ ΕΔΠ Κίνας",
};
